export const environment = {
  production: true,
  apiUrl: "https://dev-api.jidvei.ro",
  clubUrl: "https://dev-club.jidvei.ro",
  staffUrl: "https://dev-staff.jidvei.ro",
  sentryDsnClub: "",
  sentryEnvironment: "staging",
};
